
import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { delivery_modifying_list } from '../chuang/lib/modifying';
import moment from 'moment';
const _ = {
  deep_clone: require('lodash/cloneDeep')
};
const getUrl = require('baimahu/url-with-param');
const { VUE_APP_FCAPI: FCAPI } = process.env;
const Hundun = namespace('Hundun');
const API = {
  get_follower_list: `${FCAPI}/boss/hundun/company/follower`,
  get_list: `${FCAPI}/boss/hundun/company/intention`,
  cooperation_state_edit: `${FCAPI}/boss/hundun/company/status`,
  present_follower_id_edit: `${FCAPI}/boss/hundun/company/followerrele`
};
const cooperation_type_map = [
  { label: '全部', id: -2 },
  { label: '已合作', id: 3 },
  { label: '高合作意向', id: 2 },
  { label: '潜在合作意向', id: 1 },
  { label: '非目标企业', id: 4 },
  { label: '合作过期', id: 5 },
  { label: '无效企业', id: 6 },
  { label: '其他城市已合作', id: 7 }
];

const mode_multiple = {
  mode: 'multiple',
  optionLabelProp: 'children',
  filterOption: (input: any, option: any) => {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }
};
const form_list: any = {
  full_or_part_name: { tag_name: 'a-input', key: 'full_or_part_name', label: '企业', value: undefined, bind: { placeholder: '请输入' } },
  user_mobile: { tag_name: 'a-input', key: 'user_mobile', label: '手机号', value: undefined, bind: { placeholder: '请输入' } },
  cooperation_state: { tag_name: 'a-select', key: 'cooperation_state', label: '跟进状态', value: undefined, bind: { placeholder: '请输入' }, options: cooperation_type_map },
  charge_teacher_id: { tag_name: 'a-select', key: 'charge_teacher_id', label: '负责班主任', value: [], bind: { placeholder: '请输入', ...mode_multiple }, options: [] },
  present_follower_id: { tag_name: 'a-select', key: 'present_follower_id', label: '目前跟进人', value: [], bind: { placeholder: '请输入', ...mode_multiple }, options: [] },
  callback_time: { tag_name: 'a-range-picker', key: 'callback_time', label: '回访时间', value: [] },
  follow_up_content: { tag_name: 'a-input', key: 'follow_up_content', label: '备注', value: undefined, bind: { placeholder: '请输入' } }
};

@Component
export default class MissionDetail extends Vue {
  /* eslint-disable */
  @Hundun.State('teacher_list') teacher_list!: any[]; //负责班主任
  @Hundun.State('branch_office') branch_office!: any[]; //分社选项
  @Watch('teacher_list')
  valueChange(newValue: string, oldValue: string) {
    this.search_info_list.charge_teacher_id.options = newValue;
  }

  btn_list: Array<any> = [
    { id: 1, label: '导出', type: 'primary' },
    { id: 2, label: '搜索', type: 'primary' },
    { id: 3, label: '清空搜索条件', type: 'link' }
  ];
  is_loading = false;
  data_list = [];
  follower_list = [] as any;
  pagenation_info = { current: 0, limit: 0, total: 0 };
  user_define_dialog_visible = false;
  modifying_dialog_visible = false;
  user_define_form_list = [];
  dialog_form_list = _.deep_clone(delivery_modifying_list);
  search_info_list = _.deep_clone(form_list);
  upload_visible = false;
  user_define_list: any = [];
  cooperation_type_map = cooperation_type_map;
  mode_multiple = mode_multiple;

  async getList(page = 1, is_export = 0) {
    const time = this.search_info_list.callback_time.value;
    console.log(this.search_info_list.callback_time.value);

    const send_data = {
      full_or_part_name: this.search_info_list.full_or_part_name.value || undefined,
      user_mobile: this.search_info_list.user_mobile.value || undefined,
      cooperation_state: isNaN(this.search_info_list.cooperation_state.value) ? undefined : this.search_info_list.cooperation_state.value,
      charge_teacher_id: this.search_info_list.charge_teacher_id.value ? this.search_info_list.charge_teacher_id.value.join(',') : undefined,
      present_follower_id: this.search_info_list.present_follower_id.value ? this.search_info_list.present_follower_id.value.join(',') : undefined,
      callback_start_time: time.length && time[0] ? moment(time[0]).startOf('days').unix() : undefined,
      callback_end_time: time.length && time[1] ? moment(time[1]).endOf('day').unix() : undefined,
      follow_up_content: this.search_info_list.follow_up_content.value || undefined,
      current: page,
      limit: 20,
      is_export: is_export
    };

    if (is_export) {
      const res = await this.$axios.get(API.get_list, { params: send_data });
      if (res.data.status === 200) {
        this.$message.info(res.data.data);
      } else {
        window.location.href = res.request?.responseURL;
      }
    } else {
      const res = await this.$axios.get(API.get_list, { params: send_data });
      if (res.status !== 200) return this.$message.error('列表数据获取失败！');
      this.pagenation_info = { current: res.data.data?.current, limit: res.data.data?.limit, total: res.data.data?.total };
      this.data_list = res.data.data?.detail || [];
      this.data_list.forEach((element: any) => {
        element.callback_time = element.callback_time ? moment(element.callback_time * 1000) : null;
        element.present_follower_id = !element.follower_separate ? [] : element.follower_separate.map((item: any) => item.follower_id);
        element.user = element.user ? element.user : [];
      });
      console.log(this.data_list);
    }
  }
  // 翻页
  paginationOption() {
    return {
      current: this.pagenation_info.current || 0,
      total: this.pagenation_info.total || 0,
      pageSize: this.pagenation_info.limit || 0,
      showTotal: () => `共${this.pagenation_info.total}条，每页${this.pagenation_info.limit}条`
    };
  }
  // 切换分页
  async changePage(page: any) {
    this.pagenation_info.current = page.current;
    this.getList(page.current);
  }

  async editTableValue(val: any, type: string, id: number, is_delete?: boolean) {
    switch (type) {
      case 'cooperation_state':
        (async () => {
          const send_data = { id_list: [id], [type]: val };
          const res: any = await this.$axios.post(API.cooperation_state_edit, send_data);
          if (res.data.status === 200) {
            this.$message.success('修改成功');
          }
          this.getList(this.pagenation_info.current);
        })();
        break;
      case 'charge_teacher_id':
        (async () => {
          const res: any = await this.$axios.put(`${FCAPI}/boss/hundun/user/attribute/${id}?menu_id=${(window as any).route_menu_id}`, { column: type, value: val });
          if (res.data.status === 200) {
            this.$message.success('修改成功');
          }
          this.getList(this.pagenation_info.current);
        })();

        break;
      case 'present_follower_id':
        (async () => {
          const follower_name: any = this.follower_list.find((item: any) => item.id === val);
          const res: any = is_delete
            ? await this.$axios.delete(`${FCAPI}/boss/hundun/company/followerrele/0?company_id=${id}&follower_id=${val}`)
            : await this.$axios.post(`${FCAPI}/boss/hundun/company/followerrele`, {
              company_id: id,
              follower_id: val,
              follower_name: follower_name.weixin_nickname || undefined
            });
          if (res.data.status === 200) this.$message.success('修改成功');
          else this.$message.error(res.data.message);
          this.getList(this.pagenation_info.current);
        })();

        break;
      case 'callback_time':
        (async () => {
          const res: any = await this.$axios.put(`${FCAPI}/boss/hundun/company/${id}`, { [type]: val ? moment(val).unix() : 0 });
          if (res.data.status === 200) {
            this.$message.success('修改成功');
          }
          this.getList(this.pagenation_info.current);
        })();
        break;
      case 'content':
        if (!val) return;
        (async () => {
          const send_data = { company_id: id, [type]: `备注  “${val}” ` };
          const res: any = await this.$axios.post(`${FCAPI}/boss/hundun/company/log`, send_data);
          if (res.data.status === 200) {
            this.$message.success('修改成功');
          }
          this.getList(this.pagenation_info.current);
        })();
        break;
      default:
        break;
    }
  }

  btnClick(val: number) {
    switch (val) {
      case 1:
        this.getList(1, 1);
        break;
      case 2:
        this.getList();
        break;
      case 3:
        Object.keys(this.search_info_list).forEach((key: any) => {
          if (this.search_info_list[key].key == 'callback_time') {
            this.search_info_list[key].value = [];
          } else this.search_info_list[key].value = undefined;
        });
        this.user_define_list.forEach((element: any) => {
          element.value = undefined;
        });
        this.$forceUpdate();
        break;
      default:
        break;
    }
  }
  handleView(record: any) {
    this.$router.push({
      path: '/hundun/company-detail',
      query: { id: record.id, name: record.full_name }
    });
  }
  async initFollower() {
    const send_data = {
      current: 1,
      limit: 999999,
      weixin_nickname: '',
      mobile: '',
      charge: '',
      status: 0
    };
    const url = getUrl(API.get_follower_list, send_data);
    const res: any = await this.$axios.get(url);
    this.follower_list = res.data.data ? [...res.data.data.detail] : [{ id: undefined, weixin_nickname: '全部' }];
    console.log(this.follower_list);

    this.search_info_list.present_follower_id.options = [...this.follower_list, { id: 0, weixin_nickname: '无' }];
    console.log(this.search_info_list.present_follower_id.options);
  }
  async created() {
    await this.initFollower();
    if (this.$route.query?.time) {
      this.search_info_list.callback_time.value = [moment(1451577600000), moment(Number(this.$route.query?.time) * 1000)];
      this.search_info_list.present_follower_id.value = this.follower_list.filter((item: any) => this.$route.query?.name == item.charge).map((item: any) => item.id) || [];
    }

    this.getList();
  }
}
